export default "__VITE_ASSET__CPVbyAU4__"